export const NAME = 'emailTemplates';